import React from "react";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import { InputAdornment, TextField } from "@mui/material";
import styles from "./styles.module.scss";

interface ListSidebarProps {
	header?: React.ReactNode;
	searchPlaceholder?: string;
	onSearch?: (value: string) => void;
	children?: React.ReactNode;
	footer?: React.ReactNode;
}

export const ListSidebar: React.FC<ListSidebarProps> = ({ header, searchPlaceholder = "Buscar...", onSearch, children, footer }) => {
	return (
		<div className={styles.container}>
			{(header || onSearch) && (
				<div className={styles.header}>
					{header}
					{onSearch && (
						<TextField
							className={styles.searchInput}
							placeholder={searchPlaceholder}
							variant="outlined"
							size="small"
							fullWidth
							onChange={(e) => onSearch(e.target.value)}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Icon
											path={mdiMagnify}
											size={0.8}
											className={styles.searchIcon}
										/>
									</InputAdornment>
								),
							}}
						/>
					)}
				</div>
			)}
			<div className={styles.list}>{children}</div>
			{footer && <div className={styles.footer}>{footer}</div>}
		</div>
	);
};
